// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"sectionHeader-module--sectionHeader--2sq4_"};